export default __webpack_public_path__ + "static/prob1-41d195cf5f8d2eeffbe46fd0f9038b05.png";